import { useFaust } from "../../contexts/FaustContext";
import { Label } from "../ui/label";
import { Badge } from "../ui/badge";
import { cn } from "../../lib/utils";

export function DSPInfo() {
    const { state } = useFaust();
    const { dspInfo } = state;

    return (
        <div className="flex flex-col gap-1.5">
            <div className="flex items-center gap-2">
                <Label className="text-xs text-zinc-500">DSP</Label>
                <Badge
                    variant="outline"
                    className={cn(
                        "text-[10px] h-4 font-mono",
                        dspInfo
                            ? dspInfo.isWorklet
                                ? "border-green-800 text-green-500"
                                : "border-yellow-800 text-yellow-600"
                            : "border-yellow-800 text-yellow-600"
                    )}
                >
                    {dspInfo
                        ? dspInfo.isWorklet
                            ? "AudioWorklet"
                            : "ScriptProcessor"
                        : "no DSP yet"}
                </Badge>
            </div>

            {dspInfo && (
                <div className="flex flex-col gap-0.5 text-xs">
                    <div className="flex justify-between items-center py-0.5 border-b border-zinc-800/50">
                        <span className="text-zinc-500">Inputs</span>
                        <span className="text-zinc-300 font-mono">{dspInfo.inputs}</span>
                    </div>
                    <div className="flex justify-between items-center py-0.5 border-b border-zinc-800/50">
                        <span className="text-zinc-500">Outputs</span>
                        <span className="text-zinc-300 font-mono">{dspInfo.outputs}</span>
                    </div>
                    <div className="flex justify-between items-center py-0.5">
                        <span className="text-zinc-500">Params</span>
                        <span className="text-zinc-300 font-mono">{dspInfo.params}</span>
                    </div>
                </div>
            )}
        </div>
    );
}
